// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
    width: 100vw;
    max-width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    overflow-x: hidden;
    padding: 27px 0 15px 15px;
    margin: 0;
    background-color: #181b25;
}

.white-background {
    padding-right: 0 !important;
  }

.menu-desktop-container {
    width: 20%;
    padding-left: 1%;
    min-height: 100vh;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    overflow-x: hidden;
}

.menu-movil-container {
    display: none;
}

.navbar-router-container {
    width: calc(100% - 20%);
    padding: 0 15px;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    transition: width 0.3s ease;
}

/* 📏 CONTENIDO EXPANDIDO - Cuando menú está oculto */
.navbar-router-container.full-width {
    width: 100% !important;
    padding: 0 15px !important;
}

.navbar-router-container > * {
    width: 100%;
}

/* Media query para resoluciones menores o iguales a 1324px */
@media (max-width: 1324px) {
    .menu-desktop-container {
        display: none; /* Ocultar menú de escritorio */
    }

    .menu-movil-container {
        display: flex; /* Mostrar menú móvil */
        z-index: 2; /* Asegurar que el menú móvil esté por encima del navbar */
        position: absolute; /* El menú hamburguesa estará fijo en la parte superior */
        top: 0;
        right: 0;
        padding: 10px;
        background-color: #181b25;
    }

    .navbar-router-container {
        width: 100vw !important; /* El contenido ocupa el 100% del ancho */
        max-width: 100vw !important;
        /* padding-top: 60px; Añadir espacio para el menú hamburguesa */
        padding: 0 10px !important;
        margin-top: 60px;
        /* background-color: white; //Fondo blanco para evitar que se vea el azul del main-container */
        z-index: 1; /* Asegurar que esté por encima del fondo azul */
    }

    .main-container {
        padding: 27px 15px 15px 0px;
        overflow: auto; /* ✅ Permitir scroll en mobile para evitar que el background azul corte las cards */
    }
}

/* Media query para pantallas más pequeñas (menores a 500px) */
@media (max-width: 500px) {
    .main-container {
        padding: 10px 2px 10px 0px; /* ✅ Reducir padding para iPhone SE */
        overflow: auto; /* ✅ Permitir scroll en mobile para evitar que el background azul corte las cards */
    }

    .menu-desktop-container {
        display: none; /* Mantén oculto el menú de escritorio */
    }

    .menu-movil-container {
        display: flex; /* Mantén el menú móvil visible */
    }

    .navbar-router-container {
        width: 100vw !important; /* El contenido ocupa el 100% */
        max-width: 100vw !important;
        padding: 0 5px !important; /* Asegura espacio para el menú de hamburguesa */
        /* background-color: white; //Fondo blanco para evitar que se vea el azul del main-container */
        z-index: 1; /* Asegurar que esté por encima del fondo azul */
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/main-container/main-container.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;EAC7B;;AAEF;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,2BAA2B;AAC/B;;AAEA,qDAAqD;AACrD;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA,6DAA6D;AAC7D;IACI;QACI,aAAa,EAAE,+BAA+B;IAClD;;IAEA;QACI,aAAa,EAAE,uBAAuB;QACtC,UAAU,EAAE,0DAA0D;QACtE,kBAAkB,EAAE,yDAAyD;QAC7E,MAAM;QACN,QAAQ;QACR,aAAa;QACb,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB,EAAE,yCAAyC;QAClE,2BAA2B;QAC3B,+DAA+D;QAC/D,0BAA0B;QAC1B,gBAAgB;QAChB,8FAA8F;QAC9F,UAAU,EAAE,gDAAgD;IAChE;;IAEA;QACI,2BAA2B;QAC3B,cAAc,EAAE,mFAAmF;IACvG;AACJ;;AAEA,8DAA8D;AAC9D;IACI;QACI,0BAA0B,EAAE,qCAAqC;QACjE,cAAc,EAAE,mFAAmF;IACvG;;IAEA;QACI,aAAa,EAAE,wCAAwC;IAC3D;;IAEA;QACI,aAAa,EAAE,iCAAiC;IACpD;;IAEA;QACI,uBAAuB,EAAE,+BAA+B;QACxD,2BAA2B;QAC3B,yBAAyB,EAAE,gDAAgD;QAC3E,8FAA8F;QAC9F,UAAU,EAAE,gDAAgD;IAChE;AACJ","sourcesContent":[".main-container {\n    width: 100vw;\n    max-width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    overflow-x: hidden;\n    padding: 27px 0 15px 15px;\n    margin: 0;\n    background-color: #181b25;\n}\n\n.white-background {\n    padding-right: 0 !important;\n  }\n\n.menu-desktop-container {\n    width: 20%;\n    padding-left: 1%;\n    min-height: 100vh;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    overflow-x: hidden;\n}\n\n.menu-movil-container {\n    display: none;\n}\n\n.navbar-router-container {\n    width: calc(100% - 20%);\n    padding: 0 15px;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    transition: width 0.3s ease;\n}\n\n/* 📏 CONTENIDO EXPANDIDO - Cuando menú está oculto */\n.navbar-router-container.full-width {\n    width: 100% !important;\n    padding: 0 15px !important;\n}\n\n.navbar-router-container > * {\n    width: 100%;\n}\n\n/* Media query para resoluciones menores o iguales a 1324px */\n@media (max-width: 1324px) {\n    .menu-desktop-container {\n        display: none; /* Ocultar menú de escritorio */\n    }\n\n    .menu-movil-container {\n        display: flex; /* Mostrar menú móvil */\n        z-index: 2; /* Asegurar que el menú móvil esté por encima del navbar */\n        position: absolute; /* El menú hamburguesa estará fijo en la parte superior */\n        top: 0;\n        right: 0;\n        padding: 10px;\n        background-color: #181b25;\n    }\n\n    .navbar-router-container {\n        width: 100vw !important; /* El contenido ocupa el 100% del ancho */\n        max-width: 100vw !important;\n        /* padding-top: 60px; Añadir espacio para el menú hamburguesa */\n        padding: 0 10px !important;\n        margin-top: 60px;\n        /* background-color: white; //Fondo blanco para evitar que se vea el azul del main-container */\n        z-index: 1; /* Asegurar que esté por encima del fondo azul */\n    }\n\n    .main-container {\n        padding: 27px 15px 15px 0px;\n        overflow: auto; /* ✅ Permitir scroll en mobile para evitar que el background azul corte las cards */\n    }\n}\n\n/* Media query para pantallas más pequeñas (menores a 500px) */\n@media (max-width: 500px) {\n    .main-container {\n        padding: 10px 2px 10px 0px; /* ✅ Reducir padding para iPhone SE */\n        overflow: auto; /* ✅ Permitir scroll en mobile para evitar que el background azul corte las cards */\n    }\n\n    .menu-desktop-container {\n        display: none; /* Mantén oculto el menú de escritorio */\n    }\n\n    .menu-movil-container {\n        display: flex; /* Mantén el menú móvil visible */\n    }\n\n    .navbar-router-container {\n        width: 100vw !important; /* El contenido ocupa el 100% */\n        max-width: 100vw !important;\n        padding: 0 5px !important; /* Asegura espacio para el menú de hamburguesa */\n        /* background-color: white; //Fondo blanco para evitar que se vea el azul del main-container */\n        z-index: 1; /* Asegurar que esté por encima del fondo azul */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
